import React, { useMemo, useState } from "react";
import { Stack } from "@mui/material";
import { debounce } from "lodash";

import { useDealActions, useDealQueriesSelect } from "store";
import { Search } from "components";
import { useDidUpdate } from "hooks";

export const InputFilter: React.FC = () => {
  const { deal_title } = useDealQueriesSelect();

  const [searchValue, setSearchValue] = useState<string>(deal_title);

  const { updateQueries } = useDealActions();

  const debounceUpdate = useMemo(() => {
    return debounce(updateQueries, 500);
  }, []);

  useDidUpdate(() => {
    if (searchValue !== deal_title) {
      debounceUpdate({ deal_title: searchValue });
    }
  }, [searchValue]);

  useDidUpdate(() => {
    if (searchValue !== deal_title) {
      setSearchValue(deal_title);
    }
  }, [deal_title]);

  return (
    <Stack direction="row" gap="24px">
      <Search onChange={(e) => setSearchValue(e.target.value)} value={searchValue} />
      {/* 
      <Dropdown
        value={statuses.find((status) => status.id === selectedStatus)}
        onChange={(item) => updateQueries({ statuses: item.id })}
        options={[{ id: 0, name: "All statuses" }, ...statuses]}
        theme="blue-light"
        placeholder="All statuses"
      />

      <Dropdown
        value={assetClasses.find((asset) => asset.id === selectedAsset)}
        onChange={(item) => updateQueries({ assetClasses: item.id })}
        options={[{ id: 0, name: "All asset classes" }, ...assetClasses]}
        theme="blue-light"
        placeholder="All asset classes"
      /> */}
    </Stack>
  );
};
